import { FontColorEnum, FontSizeEnum, Typography } from '@acceso/design-system';

type HeadlineProps = {
  text: string;
};

export function Headline({ text }: HeadlineProps) {
  return (
    <Typography
      className="my-2 w-full border-b border-b-accent-disabled-10 px-2 py-1"
      color={FontColorEnum.Dark10}
      fontSize={FontSizeEnum.Lg}
    >
      {text}
    </Typography>
  );
}
